import React from "react";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import {
  singleSelectReducer,
  multiSelectReducer,
  tableQuestionReducer,
  questionActionTranslator,
} from "@labxchange/ui-components";
import QuestionTableReducer from "@learningblocks/simulations/shared-components/lib/Questions/QuestionTableRedux/store/reducer";

// Create Redux store for question components
const store = configureStore({
  reducer: {
    cscq: singleSelectReducer,
    mscq: multiSelectReducer,
    questionTable: QuestionTableReducer,
    tableQuestion: tableQuestionReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(questionActionTranslator),
});

interface ImageHotspotProvidersProps {
  children: React.ReactNode;
  locale: string;
  messages: Record<string, string>;
  usersnapProvider?: React.ComponentType<any>;
  usersnapProps?: any;
}

export function ImageHotspotProviders({
  children,
}: ImageHotspotProvidersProps): React.JSX.Element {
  const content = <Provider store={store}>{children}</Provider>;
  return content;
}

// Export types for convenience
export type { ImageHotspotProvidersProps };
